import { render, staticRenderFns } from "./Pets.vue?vue&type=template&id=f3aed680"
import script from "./Pets.vue?vue&type=script&lang=js"
export * from "./Pets.vue?vue&type=script&lang=js"
import style0 from "./Pets.vue?vue&type=style&index=0&id=f3aed680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports